import { render, staticRenderFns } from "./SingleInspectionQualifyChart.vue?vue&type=template&id=22d6aec3&scoped=true&"
import script from "./SingleInspectionQualifyChart.vue?vue&type=script&lang=js&"
export * from "./SingleInspectionQualifyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d6aec3",
  null
  
)

export default component.exports